<div class="row d-flex justify-content-center mb-2">
    <a class="secondary-link font-sans link-with-image" (click)="loadedTip='web-tips'">
        <span class="material-icons pr-1">
            info
        </span>
        <span [innerHTML]="'globaltext.WebTableTipsTitle' | translate"></span>
    </a>
</div>
<app-tips [show]="loadedTip=='web-tips'" (closestate)="loadedTip='';" [pageType]="'globalrichtext.ReviewWebTableTipsContent'"></app-tips>